<template>
  <div>
    <b-modal
      cancel-disabled
      size="xl"
      id="time-sheet-add-modal"
      title="ADD TIMESHEET"
      hide-footer
      scrollable
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <CreateTimeSheetForm
        modalId="time-sheet-add-modal"
        :member="teams"
        :project="projects"
        @create-timesheet="updateTimeSheet"
      />
    </b-modal>
    <TimeSheetToolBar
      :projects="projects"
      :teams="teams"
      v-on:filter-value="filter"
      class="m-3"
    />
    <v-alert
      v-if="filterError"
      type="error"
      dense
      class="mx-6 mb-2"
      dismissible
      @input="filterError = ''"
    >
      {{ filterError }}
    </v-alert>
    <v-alert v-if="filterStatus" type="info" dense class="mx-6 mb-2">
      {{ filterStatus }}
    </v-alert>
    <div class="timesheet_table">
      <b-table
        responsive
        bordered
        striped
        hover
        :items="items"
        :fields="fields"
        style="background-color: #ffab5d"
      >
        <template #cell(id)="row">
          {{ row.index }}
        </template>
        <template #cell(project_id)="row">
          <h6
            @click="GotoLink(row.item.project_id)"
            v-if="CheckLink(row.item.project_id)"
            style="color: blue"
            type="button"
            v-b-tooltip.hover
            title="Click title to redirect to gitlab board"
          >
            {{ mapIdToProjectName(row.item.project_id) }}
          </h6>
          <h6 v-else>
            {{ mapIdToProjectName(row.item.project_id) }}
          </h6>
        </template>
        <template #cell(user_id)="row">
          <div
            @click="linkToMember(row.item.user_id)"
            class="project_member_style"
          >
            {{ mapIdToUserName(row.item.user_id) }}
          </div>
        </template>
        <template #cell(project_description)="row">
          {{ row.item.log_description }}
        </template>
        <template #cell(hour)="row">
          {{ convertToHms(row.item.working_hours * 3600) }}
        </template>
        <template #cell(date)="row">
          {{ row.item.log_date }}
        </template>
        <template #cell(actions)="row">
          <v-btn
            v-b-tooltip.hover
            title="Click To Edit"
            fab
            color="#2722a6"
            v-on:click="editTimeSheet(row.item, row.index, $event.target)"
            ><v-icon color="white">mdi-pen</v-icon></v-btn
          >
        </template>
        <template #top-row>
          <b-td></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td></b-td>
          <b-td>Total Hours: {{ getTotalHoursEstimate(items) }}</b-td>
          <b-td></b-td>
          <b-td></b-td>
        </template>
      </b-table>
    </div>
    <div v-if="getTimeLogsOfAllUser.length === 0">
      <v-card tile color="#ffab5d" class="mx-6 mb-3" height="100px">
        <v-card-text
          ><h3 style="text-align: center">Result Not Found</h3></v-card-text
        >
      </v-card>
    </div>
    <b-modal
      size="xl"
      :id="editModal.id"
      scrollable
      centered
      title="Edit Time Sheet"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <EditTimeSheet
        :previewItem="editModal.item"
        :modalId="editModal.id"
        :projectList="projects"
        :memberList="teams"
        @update-timesheet="updateTimeSheet"
      ></EditTimeSheet>
    </b-modal>
  </div>
</template>
<script>
import TimeSheetToolBar from "@/components/Timesheet/TimeSheetToolBar";
import {mapActions, mapGetters} from "vuex";
import CreateTimeSheetForm from "./CreateTimeSheetForm.vue";
import EditTimeSheet from "@/components/Timesheet/EditTimeSheet";
import {convertToHm} from "@/Utilites/timerHelper";
import {
  buildTimesheetRosterLookup,
  displayNameForTimesheetUserId,
  normalizeTimesheetRowUserId,
  resolveTeamRowUserId,
} from "@/utils/timesheetRosterLookup";
import {
  resolveTimesheetProjectId,
  resolveTimesheetUserId,
} from "@/services/timesheetListApi";

export default {
  name: "ViewTimeSheet",
  components: {
    TimeSheetToolBar,
    CreateTimeSheetForm,
    EditTimeSheet,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      show: true,
      items: [],
      fields: [
        {key: "id", label: "Id", thStyle: {display: ""}, sortable: true},
        {
          key: "project_id",
          label: "Project",
          thStyle: {display: ""},
          tdClass: "test",
          sortable: true,
        },
        {
          key: "log_description",
          label: "Description",
          thStyle: {display: ""},
          tdClass: "project_description_style",
        },
        {key: "user_id", label: "User", thStyle: {display: ""}, sortable: true},
        {key: "hour", label: "Hours", thStyle: {display: ""}},

        {
          key: "log_date",
          label: "Date",
          thStyle: {display: ""},
          sortable: true,
        },
        {key: "actions", label: "Actions", thStyle: {display: ""}},
      ],
      editModal: {
        id: "edit-time-sheet-modal",
        index: "",
        item: "",
      },
      projects: [],
      teams: [],
      users: [],
      filterError: "",
      filterStatus: "",
      rosterLookup: {},
    };
  },
  computed: {
    ...mapGetters([
      "getToken",
      "userProfileData",
      "getTimeLogsOfAllUser",
      "getTeamNameList",
      "getProjectNameList",
      "getProjects",
    ]),
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions([
      "fetchProjectNameOnly",
      "fetchTeamNameList",
      "fetchTimeSheetOfAllUser",
      "showLoadingProcess",
      "closeLoading",
      "filterTimeSheetAdvanced",
      "showSnackBar",
      "closeSnackBar",
    ]),
    updateTimeSheet() {
      this.items = this.getTimeLogsOfAllUser;
    },
    getTotalHoursEstimate(items) {
      let sum = 0;
      items.forEach((item) => (sum += item.working_hours));
      return convertToHm(sum * 3600);
    },
    convertToHms: convertToHm,
    async loadData() {
      try {
        await this.fetchTeamNameList({includeNotWorking: true});
        this.rosterLookup = buildTimesheetRosterLookup(this.getTeamNameList);
        await this.fetchProjectNameOnly();
        this.loadProjectData();
        this.loadTeamData();
        await this.loadCurrentMonthTimesheets();
      } catch (err) {
        console.log(err);
      }
    },
    async loadCurrentMonthTimesheets() {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const pad = (n) => String(n).padStart(2, "0");
      const startDate = `${firstDay.getFullYear()}-${pad(
        firstDay.getMonth() + 1
      )}-${pad(firstDay.getDate())}`;
      const endDate = `${lastDay.getFullYear()}-${pad(
        lastDay.getMonth() + 1
      )}-${pad(lastDay.getDate())}`;
      await this.runTimesheetFilter({
        projects: null,
        teams: null,
        start_date: startDate,
        end_date: endDate,
      });
    },
    async runTimesheetFilter(filterForm) {
      const projectId = resolveTimesheetProjectId(
        filterForm.projects,
        this.getProjectNameList
      );
      const userId = resolveTimesheetUserId(filterForm.teams);
      if (
        filterForm.projects != null &&
        filterForm.projects !== "" &&
        projectId == null
      ) {
        throw new Error("Could not resolve the selected project.");
      }
      if (
        filterForm.teams != null &&
        filterForm.teams !== "" &&
        userId == null
      ) {
        throw new Error("Could not resolve the selected member.");
      }
      await this.filterTimeSheetAdvanced({
        projectId,
        userId,
        startDate: filterForm.start_date || "",
        endDate: filterForm.end_date || "",
      });
      this.items = this.getTimeLogsOfAllUser;
    },
    groupTimeSheetByUserId(timeSheets, id) {
      let list = [];
      timeSheets.filter((value) => {
        if (value.user_id === id) {
          list.push(value);
        }
      });
      return list;
    },
    mapIdToProjectName(id) {
      if (this.getProjectNameList.length === 0 || id === null) return;
      return this.getProjectNameList.find((item) => item.id === id)
        .project_name;
    },

    mapIdToUserName(id) {
      if (id == null) return "";
      const uid = normalizeTimesheetRowUserId({user_id: id}) ?? Number(id);
      const name = displayNameForTimesheetUserId(this.rosterLookup, uid);
      if (name && !name.startsWith("User ")) return name;
      const row = this.getTeamNameList.find(
        (item) => item.id === id || item.user === id || item.user_id === id
      );
      return row ? row.full_name : name || `User ${id}`;
    },
    editTimeSheet(items, index) {
      this.editModal.index = index;
      this.editModal.item = items;
      this.$bvModal.show(this.editModal.id);
    },

    loadProjectData() {
      this.getProjectNameList.forEach((element) => {
        this.projects.push({
          value: element.id,
          text: element.project_name,
        });
      });
    },

    loadTeamData() {
      this.teams = [];
      this.getTeamNameList.forEach((element) => {
        const userId = resolveTeamRowUserId(element);
        if (userId == null) return;
        const inactive =
          element.is_currently_working === false ? " (not working)" : "";
        this.teams.push({
          value: userId,
          text: `${element.full_name || ""}${inactive}`,
        });
      });
      this.teams.sort((a, b) => String(a.text).localeCompare(String(b.text)));
    },
    isFilterValueSet(value) {
      return value !== undefined && value !== null && value !== "";
    },
    async filter(value) {
      this.filterError = "";
      this.filterStatus = "";
      const startDate = value["start_date"];
      const endDate = value["end_date"];
      const project = value["projects"];
      if (
        !this.isFilterValueSet(project) &&
        this.isFilterValueSet(startDate) &&
        this.isFilterValueSet(endDate)
      ) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const spanDays = (end - start) / (1000 * 60 * 60 * 24);
        if (spanDays > 400) {
          this.filterStatus =
            "Large date range without a project — loading may take a minute.";
        }
      }

      await this.showLoadingProcess();
      try {
        await this.runTimesheetFilter(value || {});
        this.filterStatus = `${this.items.length} rows loaded.`;
        await this.showSnackBar({
          text: `Timesheet filter loaded (${this.items.length} rows)`,
          color: "success",
        });
        setTimeout(() => this.closeSnackBar(), 4000);
      } catch (err) {
        this.filterError =
          (err && err.message) ||
          "Timesheet filter failed. The previous results are cleared.";
        this.items = [];
        this.$store.commit("setUserTimeSheetData", []);
        await this.showSnackBar({
          text: this.filterError,
          color: "error",
        });
        setTimeout(() => this.closeSnackBar(), 6000);
      } finally {
        await this.closeLoading();
      }
    },
    CheckLink(id) {
      let projectBoardUrl = "";
      this.getProjects.map((oneProject) => {
        if (oneProject.id === id) {
          projectBoardUrl = oneProject.source_control_link1;
        }
      });
      return !(projectBoardUrl === "" || projectBoardUrl === null);
    },
    GotoLink(id) {
      let projectBoardUrl = "";
      this.getProjects.map((oneProject) => {
        if (oneProject.id === id) {
          projectBoardUrl = oneProject.source_control_link1;
        }
      });
      window.open(projectBoardUrl, "_blank").focus();
    },
    linkToMember(user_id) {
      this.$router.push({name: "MemberInfo", params: {userId: user_id}});
    },
  },
};
</script>
<style>
.project_description_style {
  white-space: pre-line;
}
</style>
<style scoped>
.project_member_style {
  cursor: pointer;
}
.timesheet_table {
  padding-inline: 200px;
}
@media only screen and (max-width: 1100px) {
  .timesheet_table {
    padding: 0px;
  }
}
</style>
